export type StreamCardTargetsInput = {
  customTargetsData: { minTargets: number } | null | undefined;
  following?: boolean | null;
  customTargets?: readonly string[] | null;
};

export type StreamCardTargetsV2Props = {
  minTargets: number;
  targets?: readonly string[];
};

export const streamCardTargetsV2 = (
  stream: StreamCardTargetsInput,
): StreamCardTargetsV2Props | null => {
  if (!stream.customTargetsData) {
    return null;
  }

  const submitted =
    stream.following && stream.customTargets && stream.customTargets.length > 0
      ? stream.customTargets
      : undefined;

  return {
    minTargets: stream.customTargetsData.minTargets,
    ...(submitted ? { targets: submitted } : {}),
  };
};
